import { gql } from 'graphql-tag'

export const login = gql`
  mutation Login($login: String!, $password: String!, $recaptchaToken: String) {
    login(login: $login, password: $password, recaptchaToken: $recaptchaToken) {
      token
    }
  }
`

export const addToFavoritesMutation = gql`
  mutation AddToFavorites($slug: String!) {
    addToFavorites(slug: $slug) {
      success
    }
  }
`

export const removeFromFavoritesMutation = gql`
  mutation RemoveFromFavorites($slug: String!) {
    removeFromFavorites(slug: $slug) {
      success
    }
  }
`

export const resetPasswordMutation = gql`
  mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
    changePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
      id
      changedPassword
    }
  }
`

export const resetPasswordFirstLoginMutation = gql`
  mutation ResetPasswordFirstLoginMutation($newPassword: String!) {
    changePasswordFirstLogin(newPassword: $newPassword) {
      id
      changedPassword
    }
  }
`

export const resetPasswordToDefault = gql`
  mutation ResetPasswordToDefault($readerId: Int!) {
    resetPassword(readerId: $readerId)
  }
`

export const fullPasswordReset = gql`
  mutation FullPasswordReset($readerId: Int!) {
    fullPasswordReset(readerId: $readerId)
  }
`

export const likeOrDislikeSharedReadingMutation = gql`
  mutation likeOrDislikeSharedReading($slug: String!) {
    likeOrDislikeSharedReading(slug: $slug)
  }
`

export const createSharedReadingMutation = gql`
  mutation createSharedReading($slug: String!) {
    createSharedReading(slug: $slug) {
      shares
    }
  }
`

export const getUserMutation = gql`
  mutation GetUserMutation($login: String!, $recaptchaToken: String) {
    getUser(login: $login, recaptchaToken: $recaptchaToken) {
      response_type
      info
    }
  }
`

export const createEntityMutation = gql`
  mutation CreateEntity(
    $degree: String!
    $name: String!
    $parentEntityId: Int!
  ) {
    createEntity(
      degree: $degree
      name: $name
      parentEntityId: $parentEntityId
    ) {
      id
    }
  }
`

export const editEntityMutation = gql`
  mutation EditEntity($degree: String!, $name: String!, $entityId: Int!) {
    editEntity(degree: $degree, name: $name, entityId: $entityId)
  }
`

export const deleteEntityMutation = gql`
  mutation deleteEntity($entityId: Int!) {
    deleteEntity(entityId: $entityId)
  }
`

export const deactivateEntitiesMutation = gql`
  mutation deactivateEntities($entityIds: [Int]!) {
    deactivateEntities(entityIds: $entityIds)
  }
`

export const createBatchEntitiesMutation = gql`
  mutation createBatchEntities($entityParams: [EntityParamsInput]) {
    createBatchEntities(entityParams: $entityParams) {
      name
    }
  }
`

export const createSelfReferralMutation = gql`
  mutation CreateSelfReferral($role: String!) {
    createSelfReferral(role: $role) {
      referralType
      role
    }
  }
`

export const curationUnpublishMutation = gql`
  mutation CurationUnpublish($publicDataActivityId: Int!) {
    curationUnpublish(publicDataActivityId: $publicDataActivityId) {
      id
    }
  }
`

export const curationApproveMutation = gql`
  mutation CurationApprove($publicDataActivityId: Int!) {
    curationApprove(publicDataActivityId: $publicDataActivityId) {
      id
    }
  }
`
export const curationPublishMutation = gql`
  mutation CurationPublish($publicDataActivityId: Int!) {
    curationPublish(publicDataActivityId: $publicDataActivityId) {
      id
    }
  }
`
export const curationRefuseMutation = gql`
  mutation CurationRefuse($publicDataActivityId: Int!) {
    curationRefuse(publicDataActivityId: $publicDataActivityId) {
      id
    }
  }
`

export const editUserMutation = gql`
  mutation editUserMutation($readerId: Int!, $name: String, $bornDate: String) {
    editUser(readerId: $readerId, name: $name, bornDate: $bornDate) {
      id
    }
  }
`

export const deleteUserMutation = gql`
  mutation deactivateUser($readerId: Int!) {
    deactivateUser(readerId: $readerId)
  }
`

export const createReaderMutation = gql`
  mutation CreateReader($entityId: Int!, $name: String!, $email: String) {
    createReader(entityId: $entityId, name: $name, email: $email) {
      id
    }
  }
`

export const createTeacherMutation = gql`
  mutation CreateTeacher(
    $entityId: Int!
    $name: String!
    $email: String!
    $permissions: String!
  ) {
    createTeacher(
      entityId: $entityId
      name: $name
      email: $email
      permissions: $permissions
    ) {
      id
    }
  }
`

export const changeTeacherPermissionsMutation = gql`
  mutation changeTeacherPermissions(
    $teacherId: Int!
    $canCreateAdmin: Boolean
    $canDeleteAdmin: Boolean
    $canCreateReader: Boolean
    $canDeleteReader: Boolean
  ) {
    changeAdminPermissions(
      teacherId: $teacherId
      canCreateAdmin: $canCreateAdmin
      canDeleteAdmin: $canDeleteAdmin
      canCreateReader: $canCreateReader
      canDeleteReader: $canDeleteReader
    ) {
      success
    }
  }
`

export const updateTeacherInfo = gql`
  mutation updateTeacherInfo(
    $roles: [String]
    $yearsResponsibleFor: [String]
    $disciplines: [String]
    $email: String
    $phone: String
  ) {
    updateTeacherInfo(
      roles: $roles
      yearsResponsibleFor: $yearsResponsibleFor
      disciplines: $disciplines
      email: $email
      phone: $phone
    ) {
      name
    }
  }
`

export const skipTeacherUpdate = gql`
  mutation skipTeacherUpdate {
    skipTeacherUpdate {
      skips
      updated
    }
  }
`

export const confirmTeacherEmail = gql`
  mutation confirmTeacherEmail($code: String!) {
    confirmTeacherEmail(code: $code) {
      emailConfirmed
    }
  }
`

export const removeShelfMutation = gql`
  mutation removeBookShelf($bookShelfId: Int!) {
    removeBookShelf(bookShelfId: $bookShelfId) {
      id
    }
  }
`

export const activateShelfMutation = gql`
  mutation activateBookShelf($bookShelfId: Int!) {
    activateBookshelf(bookShelfId: $bookShelfId) {
      id
    }
  }
`

export const deactivateShelfMutation = gql`
  mutation deactivateBookShelf($bookShelfId: Int!) {
    deactivateBookshelf(bookShelfId: $bookShelfId) {
      id
    }
  }
`

export const duplicateShelfMutation = gql`
  mutation duplicateShelf($bookShelfId: Int!, $degreeRange: String!) {
    duplicateBookshelf(bookShelfId: $bookShelfId, degreeRange: $degreeRange) {
      name
      active
      degreeRange
      type
      id
      isHighlight
      bookShelfItems {
        book {
          slug
          name
          imageUrlThumb
          author
        }
        bookShelfId
        id
        mascot
      }
    }
  }
`

export const updateShelfMutation = gql`
  mutation updateBookShelf(
    $bookShelfId: Int!
    $degreeRange: String!
    $contentFilter: String
    $name: String!
    $subtitle: String
    $acervoType: String!
    $isHighlight: Boolean!
    $type: String!
    $description: String
    $image: String
    $bgColor: String
  ) {
    updateBookShelf(
      bookShelfId: $bookShelfId
      degreeRange: $degreeRange
      contentFilter: $contentFilter
      name: $name
      subtitle: $subtitle
      acervoType: $acervoType
      isHighlight: $isHighlight
      type: $type
      description: $description
      image: $image
      bgColor: $bgColor
    ) {
      id
    }
  }
`

export const uploadBookShelfImageMutation = gql`
  mutation uploadBookShelfImage($file: Upload!) {
    uploadBookShelfImage(file: $file)
  }
`

export const removeBookFromShelfMutation = gql`
  mutation removeBookFromBookShelf($bookShelfId: Int!, $slug: String!) {
    removeBookFromBookShelf(bookShelfId: $bookShelfId, slug: $slug) {
      id
    }
  }
`

export const addBooksToShelfMutation = gql`
  mutation addBooksToBookShelf(
    $bookShelfId: Int!
    $slugs: [String!]
    $mascot: String
  ) {
    addBooksToBookShelf(
      bookShelfId: $bookShelfId
      slugs: $slugs
      mascot: $mascot
    ) {
      book {
        slug
      }
      id
    }
  }
`

export const createShelfMutation = gql`
  mutation createBookShelf(
    $name: String!
    $subtitle: String!
    $degreeRange: String!
    $contentFilter: String!
    $order: [Int]
    $isHighlight: Boolean!
    $acervoType: String!
    $type: String!
    $description: String
    $image: String
    $bgColor: String
  ) {
    createBookShelf(
      name: $name
      subtitle: $subtitle
      degreeRange: $degreeRange
      contentFilter: $contentFilter
      order: $order
      isHighlight: $isHighlight
      acervoType: $acervoType
      type: $type
      description: $description
      image: $image
      bgColor: $bgColor
    ) {
      id
    }
  }
`

export const changeShelfPlaylistOrderPriorityMutation = gql`
  mutation changeOrderFromBookShelf($order: [Int]) {
    changeOrderFromBookShelf(order: $order) {
      id
    }
  }
`

// BNCC Didactic Sequence MUTATIONS
export const createDidacticSequenceMutation = gql`
  mutation createDidacticSequence($author: String!, $title: String!) {
    createDidacticSequence(author: $author, title: $title) {
      id
      title
    }
  }
`
export const deleteDidacticSequenceMutation = gql`
  mutation deleteDidacticSequence($didacticSequenceId: Int!) {
    deleteDidacticSequence(didacticSequenceId: $didacticSequenceId) {
      id
    }
  }
`

export const createBnccActivityMutation = gql`
  mutation CreateAtivity($didacticSequenceId: Int, $title: String!) {
    createAtivity(didacticSequenceId: $didacticSequenceId, title: $title) {
      didacticSequenceId
      title
      isBncc
    }
  }
`

export const favoriteDidacticSequenceMutation = gql`
  mutation FavoriteDidacticSequence($didacticSequenceId: Int!) {
    favoriteDidacticSequence(didacticSequenceId: $didacticSequenceId) {
      info
      success
    }
  }
`

export const unfavoriteDidacticSequenceMutation = gql`
  mutation UnfavoriteDidacticSequence($didacticSequenceId: Int!) {
    unfavoriteDidacticSequence(didacticSequenceId: $didacticSequenceId) {
      info
      success
    }
  }
`

export const publishDidacticSequenceMutation = gql`
  mutation PublishDidacticSequenceMutation($didacticSequenceId: Int!) {
    publishDidacticSequence(didacticSequenceId: $didacticSequenceId) {
      id
    }
  }
`
export const unpublishDidacticSequenceMutation = gql`
  mutation UnpublishDidacticSequenceMutation($didacticSequenceId: Int!) {
    unpublishDidacticSequence(didacticSequenceId: $didacticSequenceId) {
      id
    }
  }
`
// END BNCC Didactic Sequence MUTATIONS

// NEW Activities
export const createActivityMutation = gql`
  mutation CreateActivity($title: String!) {
    createActivity(title: $title) {
      id
      title
    }
  }
`
export const setActivityTitleMutation = gql`
  mutation SetActivityTitle($title: String!, $activityId: Int!) {
    setActivityTitle(title: $title, activityId: $activityId) {
      id
      title
    }
  }
`

export const curationChangeActivityTitleMutation = gql`
  mutation CurationChangeActivityTitle($title: String!, $activityId: Int!) {
    curationChangeActivityTitle(title: $title, activityId: $activityId) {
      id
      title
    }
  }
`

export const curationChangePublicDataEmailMutation = gql`
  mutation CurationChangePublicDataEmail($email: String!, $activityId: Int!) {
    curationChangePublicDataEmail(email: $email, activityId: $activityId) {
      id
    }
  }
`

export const curationChangePublicDataDegreeRangeMutation = gql`
  mutation CurationChangePublicDataDegreeRange(
    $degreeRange: [String]!
    $activityId: Int!
  ) {
    curationChangePublicDataDegreeRange(
      degreeRange: $degreeRange
      activityId: $activityId
    ) {
      id
    }
  }
`

export const setActivityToReadyMutation = gql`
  mutation SetActivityToReady($activityId: Int!) {
    setActivityToReady(activityId: $activityId) {
      id
    }
  }
`

export const deleteActivity = gql`
  mutation deleteActivity($activityId: Int!) {
    deleteActivity(activityId: $activityId) {
      id
    }
  }
`

export const editAppliedActivity = gql`
  mutation EditAppliedActivity($input: EditAppliedActivityInput!) {
    editAppliedActivity(input: $input) {
      id
    }
  }
`

export const duplicateActivityMutation = gql`
  mutation DuplicateActivity($activityId: Int!) {
    duplicateActivity(activityId: $activityId) {
      title
      id
      isReady
      submittedToPublic
    }
  }
`

export const setNpsRatingMutation = gql`
  mutation setNpsRatingMutation(
    $score: Int!
    $source: String!
    $reason: String
  ) {
    scoreNps(score: $score, source: $source, reason: $reason) {
      source
      score
      createdAt
    }
  }
`

export const trialFirstAccessMutation = gql`
  mutation setTrialFirstAccessData($entityCode: String, $name: String!) {
    setTrialFirstAccessData(entityCode: $entityCode, name: $name) {
      id
    }
  }
`

export const trialSelfRegisterMutation = gql`
  mutation trialSelfRegister(
    $captcha: String
    $code: String!
    $codeType: CodeType!
    $email: String
    $name: String!
    $phone: String
    $state: String
    $city: String
    $degree: String
    $referrerId: Int
    $role: String
    $schoolName: String
  ) {
    selfRegister(
      captcha: $captcha
      code: $code
      codeType: $codeType
      email: $email
      name: $name
      phone: $phone
      state: $state
      city: $city
      degree: $degree
      referrerId: $referrerId
      role: $role
      schoolName: $schoolName
    ) {
      accessToken
    }
  }
`

export const setLastDayAccessToReader = gql`
  mutation setLastDayAccessToReader($days: Int!, $readerId: Int!) {
    setLastDayAccessToReader(days: $days, readerId: $readerId) {
      id
    }
  }
`

export const buySeedMutation = gql`
  mutation buySeed($input: BuySeedInput) {
    buySeed(input: $input) {
      status
      reason
      message
    }
  }
`

export const buySpecialItemMutation = gql`
  mutation buySpecialItem($input: BuySpecialItemInput) {
    buySpecialItem(input: $input) {
      status
    }
  }
`

export const registerScoreCsat = gql`
  mutation scoreCsat($context: CsatContext!, $score: Int!) {
    scoreCsat(context: $context, score: $score, source: "Web") {
      score
    }
  }
`

export const registerJustifyCsat = gql`
  mutation justifyCsat($context: CsatContext!, $reason: String) {
    justifyCsat(context: $context, reason: $reason) {
      reason
    }
  }
`
export const createOrUpdateClient = gql`
  mutation CreateOrUpdateClient($input: CreateOrUpdateClientInput!) {
    createOrUpdateClient(input: $input) {
      id
    }
  }
`

export const deactivateClient = gql`
  mutation deactivateClient($clientId: Int!) {
    deactivateClient(clientId: $clientId) {
      id
    }
  }
`

export const toggleClient = gql`
  mutation toggleClient($clientId: Int!) {
    toggleClient(clientId: $clientId) {
      id
    }
  }
`
export const setContractModuleToEntityMutation = gql`
  mutation ($input: SetContractModuleToEntityInput!) {
    SetContractModuleToEntity(input: $input)
  }
`

export const removeContractModuleFromEntityMutation = gql`
  mutation removeContractModuleFromEntityMutation(
    $input: RemoveContractModuleFromEntityInput!
  ) {
    RemoveContractModuleFromEntity(input: $input)
  }
`

export const createOrUpdateContractMutation = gql`
  mutation createOrUpdateContract($input: CreateOrUpdateContractInput!) {
    createOrUpdateContract(input: $input) {
      contractId
    }
  }
`

export const createOrUpdateModuleAndObservationMutation = gql`
  mutation createOrUpdateModuleAndObservation(
    $input: CreateOrUpdateModuleAndObservationInput!
  ) {
    createOrUpdateModuleAndObservation(input: $input) {
      contractId
    }
  }
`

export const activateOrDeactivateContractMutation = gql`
  mutation activateOrDeactivateContract($active: Boolean!, $contractId: Int!) {
    activateOrDeactivateContract(active: $active, contractId: $contractId) {
      active
    }
  }
`

export const setContractMarketMutation = gql`
  mutation setContractMarket($contractId: Int!, $market: String!) {
    setContractMarket(contractId: $contractId, market: $market) {
      contractId
      market
    }
  }
`

export const setContractDatesAndWarningMutation = gql`
  mutation setContractDatesAndWarning(
    $input: SetContractDatesAndWarningInput!
  ) {
    setContractDatesAndWarning(input: $input) {
      contractId
    }
  }
`

export const setFinanceContactMutation = gql`
  mutation setFinanceContact($input: SetFinanceContactInput!) {
    setFinanceContact(input: $input) {
      contractId
    }
  }
`

export const toggleUsesContractModuleSystemMutation = gql`
  mutation toggleUsesContractModuleSystem(
    $input: ToggleUsesContractModuleSystemInput!
  ) {
    toggleUsesContractModuleSystem(input: $input)
  }
`

export const cancelImportationMutation = gql`
  mutation cancelImportation($id: Int!) {
    cancelImportation(id: $id) {
      id
    }
  }
`

export const processImportationMutation = gql`
  mutation processImportation($id: Int!) {
    processImportation(id: $id) {
      id
    }
  }
`

// My Readings control mutations
export const markBookAsReadMutation = gql`
  mutation ($bookSlug: String!) {
    markBookAsRead(bookSlug: $bookSlug) {
      status
    }
  }
`

export const markBookAsReadingMutation = gql`
  mutation ($bookSlug: String!) {
    markBookAsReading(bookSlug: $bookSlug) {
      status
    }
  }
`

export const markBookAsUnreadMutation = gql`
  mutation ($bookSlug: String!) {
    markBookAsUnread(bookSlug: $bookSlug) {
      deleted
    }
  }
`

export const markBookAsHiddenMutation = gql`
  mutation ($bookSlug: String!) {
    markBookAsHidden(bookSlug: $bookSlug) {
      status
    }
  }
`

export const markBookAsVisibleMutation = gql`
  mutation ($bookSlug: String!) {
    markBookAsVisible(bookSlug: $bookSlug) {
      removed
    }
  }
`

export const loginFamilyPayingUserForPayment = gql`
  mutation loginUserForPayment($userId: Int!, $rootId: Int!) {
    loginUserForPayment(userId: $userId, rootId: $rootId) {
      token
    }
  }
`

export const moveSingleReaderMutation = gql`
  mutation moveReaderMutation($entityId: Int!, $readerId: Int!) {
    moveReader(entityId: $entityId, readerId: $readerId)
  }
`

export const arvoreSharedReadingMutation = gql`
  mutation arvoreSharedReadingMutation($input: ArvoreSharedReadingInput!) {
    arvoreSharedReading(input: $input) {
      sharedReadingId
    }
  }
`

// Atualidades
export const disableArticleMutation = gql`
  mutation disableArticle($id: Int!) {
    disableArticle(id: $id) {
      id
      title
      subtitle
      degree
      author
    }
  }
`

export const publishArticleMutation = gql`
  mutation publishArticle($id: Int!) {
    publishArticle(id: $id) {
      publishDate
    }
  }
`

export const unpublishArticleMutation = gql`
  mutation unpublishArticle($id: Int!) {
    unpublishArticle(id: $id) {
      publishDate
    }
  }
`

export const uploadArticleImageMutation = gql`
  mutation uploadArticleImage($articleId: Int!, $image: Upload!) {
    uploadArticleImage(articleId: $articleId, image: $image) {
      imageUrl
    }
  }
`

export const updateImportationLineMutation = gql`
  mutation updateImportationLine(
    $input: UpdateImportationLineInput!
    $lineId: Int!
  ) {
    updateImportationLine(input: $input, lineId: $lineId) {
      importationLine {
        id
        status
        info
      }
      updateStatus
    }
  }
`

export const processImportationSuggestionMutation = gql`
  mutation processImportationSuggestion(
    $lineId: Int!
    $suggestionContent: SuggestionContentInput!
  ) {
    processImportationSuggestion(
      lineId: $lineId
      suggestionContent: $suggestionContent
    ) {
      importationLine {
        id
        status
        info
      }
      updateStatus
    }
  }
`

export const seekAndDestroyEmptyClassesMutation = gql`
  mutation SeekAndDestroyEmptyClasses($clientId: Int!) {
    seekAndDestroyEmptyClasses(clientId: $clientId) {
      deletedClasses
    }
  }
`
